import type { RouteObject } from 'react-router-dom'
import { LanguageProvider } from '@/context/LanguageContext'
import Ebook from '@/pages/Ebook'
import Home from '@/pages/Home'
import { useRoutes } from 'react-router-dom'

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/ebook', element: <Ebook /> },
]

function App() {
  const element = useRoutes(routes)
  return (
    <LanguageProvider>
      {element}
    </LanguageProvider>
  )
}

export default App
